import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { useAuthStore } from '../../auth/stores/authStore';

export const bookingDetailsKeys = {
  all: ['booking-details'] as const,
  detail: (allocationId: string, isAuthenticated: boolean) =>
    [...bookingDetailsKeys.all, { allocationId, isAuthenticated }] as const,
};

export function useBookingDetails(allocationId: string | null) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: bookingDetailsKeys.detail(allocationId ?? '', isAuthenticated),
    queryFn: async ({ signal }) => {
      if (!allocationId) return null;

      return unwrap(
        await api.pricework.GET(
          '/pricework/api/v1/allocations/{allocationId}',
          {
            params: { path: { allocationId } },
            signal,
          }
        )
      );
    },
    enabled: isAuthenticated && !!allocationId,
    staleTime: 30_000,
  });
}
